import type { RectangleSchemaType } from '@vedalib/editor/lib/brand'
import { textToRtValue } from '@vedalib/rich-text'

import { RichTextViewer } from 'components/form/RichText/RichTextViewer'
import { useFontCss } from 'services/Branding/hooks'
import { DeviceMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import { useElementRootStyles } from '../../hooks/useElementRootStyles'

const RectangleDemo: FCDemoType<RectangleSchemaType> = ({ styles }) => {
  const fontStyles = useFontCss(DeviceMode.desktop)
  const rootStyles = useElementRootStyles(
    styles.root,
    { width: 470, padding: '100px 0', textAlign: 'center' },
    styles.rectangle,
    styles.border,
    styles.effects,
  )
  return (
    <DemoWrapper center full>
      <div style={rootStyles}>
        <RichTextViewer
          styles={fontStyles}
          value={textToRtValue(t('elements.rectangle.label.demo'))}
        />
      </div>
    </DemoWrapper>
  )
}
export default RectangleDemo
